const n = `<svg viewBox="0 0 128 128" fill="currentColor">
    <path d="M0 0h61.4L0 60.4zM0 128L128 0H64.6L0 63.7zM128 128L64.6 66.6 3.3 128z" />
</svg>`;
export {
  n as default
};
